export default __webpack_public_path__ + "static/media/money.20627f30.png";